import Connections from '../../connections';
import {
    action, observable,
} from 'mobx';
import {
    createFacilityGroup,
    getFacilityGroups,
    getFacilityGroupById,
    updateFacilityGroup,
    updateFacilityGroupStatus,
    getFacilityGroupQR,
} from '../../axios/facilitieGroupRequests';
import {
    convertCountriesToISOCodeString,
} from '../../constants/countries';
import {
    DefaultLanguage,
} from '../../constants/languages';
import {
    getHeader,
} from '../../helperFunctions/getHeader';
import {
    ICountry,
} from '../storeInterfaces/authInterface';
import {
    IGroup, GroupModel, ICreateGroup,
} from '../storeInterfaces/groupInterface';
import { FirebaseDynamicLinks } from 'firebase-dynamic-links';


import { uploadFile, uploadSingleImage } from '../../helperFunctions/uploadService';
import { uploadFileURL } from '../../axios/requests';
import { RequestStatus } from 'mobx-store';
import {IFacilityGroupStore} from "../storeInterfaces/facilityGroupsInterface";
import {firebaseConfig} from "../../connections/Firebase/environment";

export class FacilityGroupStore implements IFacilityGroupStore {

    androidInfo: any;

    iosInfo: any;

    constructor() {
        this.androidInfo = {
            androidPackageName: firebaseConfig.android.packageName,
        };
        this.iosInfo = {
            iosBundleId: firebaseConfig.iOS.bundleId,
            iosAppStoreId: firebaseConfig.iOS.appstoreId,
        };
    }
    @observable groupsList: IGroup[] = [];

    @observable selectedGroup = {
    };

    @observable loading = false;

    @observable facilityGroupQR = '';

    @observable getFacilitiesGroupsRequestStatus: RequestStatus = RequestStatus.IDLE;

    private static restructureFacilityGroup(Group: IGroup): any {
        return {
            GroupId: Group.FacilityGroupId,
            title: Group.title,
            facilityArea: Group.facilityArea?Group.facilityArea.facilityAreaId:-1,
            isActive: Group.isActive,
            imageUrl: (Group.imageUrl ? [{
                imageUrl: Group.imageUrl,
            }] : []),
        };
    }

    private static restructureFacilityGroupsList(Groups: IGroup[]): any[] {
        return Groups.map((Group: IGroup) => ({
            ...Group,
            editForm: 'Edit Form',
            generate: 'Generate',
        }));
    }

    @action
    public async getFacilityGroups(countries: ICountry[], type: string, langCode: string = DefaultLanguage,areaId:number =0): Promise<void> {
        try {
            this.loading = true;
            this.getFacilitiesGroupsRequestStatus = RequestStatus.LOADING;
            const availableCountries = convertCountriesToISOCodeString(countries);

            const params = {
                availableCountries,
                status:"all",
                areaId:areaId||null
            };

            const config = {
                ...getHeader(langCode), params,
            };

            const response = await Connections.wadiDeglaAxios.httpGet(getFacilityGroups, config);
            console.info(response)
            this.groupsList = FacilityGroupStore.restructureFacilityGroupsList(response.data);
            this.getFacilitiesGroupsRequestStatus = RequestStatus.SUCCESS;
        } catch (error) {
            this.getFacilitiesGroupsRequestStatus = RequestStatus.FAILED;
            console.log(error);
        } finally {
            this.loading = false;
        }
    }

    @action.bound
    public async getFacilityGroupById(id: number, langCode: string = DefaultLanguage): Promise<void> {
        try {
            this.loading = true;
            const response = await Connections.wadiDeglaAxios.httpGet(getFacilityGroupById(id), getHeader(langCode));
            this.selectedGroup = FacilityGroupStore.restructureFacilityGroup(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            this.loading = false;
        }
    }

    @action.bound
    public async createFacilityGroup(newGroup: ICreateGroup, langCode: string = DefaultLanguage): Promise<void> {
        return new Promise<void>(async (res, rej) => {
            try {
                let imageUrl = null;
                if (newGroup.imageUrl) {
                    imageUrl = await uploadSingleImage(newGroup.imageUrl);
                }
                const GroupToCreate: GroupModel = {
                    FacilityGroupId: newGroup.FacilityGroupId,
                    facilityArea: newGroup.facilityArea,
                    imageUrl,
                    isActive: newGroup.isActive,
                    title: newGroup.title,
                    availableCountries: newGroup.availableCountries,
                };
                const response = await Connections.wadiDeglaAxios.httpPost(createFacilityGroup, GroupToCreate, getHeader(langCode));
                res(response.data.FacilityGroupId);
            } catch (error) {
                rej(error);
            }
        });
    }

    @action.bound
    public async updateFacilityGroupStatus(updatedGroupStatus: boolean, index: number): Promise<void> {
        try {
            await Connections.wadiDeglaAxios.httpPut(updateFacilityGroupStatus(this.groupsList[index].FacilityGroupId),
                {
                    isActive: updatedGroupStatus,
                });
        } catch (error) {
            console.log(error);
        } finally {
            this.groupsList[index].isActive = updatedGroupStatus;
        }
    }

    @action.bound
    public async updateFacilityGroup(updatedGroup: ICreateGroup, GroupId: number, langCode: string = DefaultLanguage): Promise<void> {
        try {
            let imageUrl = null;
            if (updatedGroup.imageUrl) {
                imageUrl = await uploadSingleImage(updatedGroup.imageUrl);
            }
            const GroupToUpdate: GroupModel = {
                FacilityGroupId: updatedGroup.FacilityGroupId,
                facilityArea: updatedGroup.facilityArea,
                imageUrl,
                isActive: updatedGroup.isActive,
                title: updatedGroup.title,
                availableCountries: updatedGroup.availableCountries,
            };
            await Connections.wadiDeglaAxios.httpPut(updateFacilityGroup(GroupId), GroupToUpdate, getHeader(langCode));
        } catch (error) {
            console.log(error);
        }
    }

    @action.bound public async getFacilityGroupQR(id : number, langCode : string = DefaultLanguage): Promise < void > {
        try {

         /*   const response = await Connections.wadiDeglaAxios.httpGet(getFacilityGroupQR(id), getHeader(langCode));
            this.facilityGroupQR = response.data.image;*/
            this.facilityGroupQR = await  this.creatDynamicLink(id);
        } catch (error) {
            console.log(error);
        }
    }
    @action.bound public async creatDynamicLink(id:any){

       const webKey=firebaseConfig.apiKey;
       const portalURL=firebaseConfig.PORTAL_URL;
       const dynamicLinkPrefix=firebaseConfig.DYNAMIC_LINK_PREFIX;

       const args={
           redirect:"redirectScannedQRScreen",
           entityId: `group_${id}`,
           params: ``,
       };
        const link = `${portalURL}?redirect=${args.redirect}${args.entityId ? `&entityId=${args.entityId}` : ""}${args.params ? `&params=${JSON.stringify(args.params)}` : ""}`;


        const firebaseDynamicLinks = new FirebaseDynamicLinks(webKey);



        const { shortLink } = await firebaseDynamicLinks.createLink({
            dynamicLinkInfo: {
                link: encodeURI(link),
                domainUriPrefix: dynamicLinkPrefix,
                androidInfo: this.androidInfo,
                iosInfo: this.iosInfo,
            },
            suffix: {
                option: "UNGUESSABLE",
            },
        });
        var QRCode = require('qrcode')
        const qr =   QRCode.toDataURL(shortLink, {
            errorCorrectionLevel: "Q",
            version: 10, // qr size
        });
        console.info(shortLink)
        return qr;
    }
}
